module.exports = __webpack_public_path__ + "static/img/moments-console.47613908.png";